import { render, staticRenderFns } from "./Enregistrement.vue?vue&type=template&id=dedae0e8&scoped=true&"
import script from "./Enregistrement.vue?vue&type=script&lang=js&"
export * from "./Enregistrement.vue?vue&type=script&lang=js&"
import style0 from "./Enregistrement.vue?vue&type=style&index=0&id=dedae0e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedae0e8",
  null
  
)

component.options.__file = "Enregistrement.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardText,
  VContainer,
  VFlex,
  VForm,
  VIcon,
  VLayout,
  VTextField,
})
